<template>
  <div class="company-info" v-show="!loading">
    <!-- Banner -->
    <div class="banner">
      <img :src="preloadedImages.png03" alt="Company Profile" class="banner-img">
      <div class="overlay"></div>
      <div class="banner-text">
        <h1>{{ $t('companyInfo') }}</h1>
        <h3>{{ $t('companyInfo1') }}</h3>
      </div>
    </div>

    <!-- Achievements Section -->
    <!-- <div id="achievements" class="section achievements" v-observe-visibility="onVisibilityChange">
      <div class="achievements-header">
        <h2>{{ $t('achievementsTitle') }}</h2>
      </div>
      <div class="achievements-content">
        <p v-html="$t('achievementsMission')"></p>
        <p v-html="$t('achievementsService')"></p>
        <p v-html="$t('achievementsEmployee')"></p>
      </div>
    </div> -->

    <!-- Vision Section -->
    <div id="vision" class="section vision" v-observe-visibility="onVisibilityChange">
      <div class="vision-header">
        <h2>{{ $t('visionTitle') }}</h2>
      </div>
      <div class="vision-content">
        <p v-html="$t('visionMission')"></p>
        <p v-html="$t('visionService')"></p>
        <p v-html="$t('visionEmployee')"></p>
      </div>
      <img :src="preloadedImages.png04" alt="Company Profile" class="img" v-if="preloadedImages.png04">
    </div>

    <!-- Company Profile Section -->
    <div id="companyprofile" class="section companyprofile" v-observe-visibility="onVisibilityChange">
      <div class="vision-header">
      <h2>{{ $t('companyProfileTitle') }}</h2>
      </div>
      <table class="company-table">
        <tr>
          <td class="first-child">{{ $t('companyNameLabel') }}</td>
          <td>{{ $t('companyName') }}</td>
        </tr>
        <tr>
          <td class="first-child">{{ $t('capitalLabel') }}</td>
          <td>{{ $t('capital') }}</td>
        </tr>
        <tr>
          <td class="first-child">{{ $t('ceoLabel') }}</td>
          <td>{{ $t('ceoName') }}</td>
        </tr>
        <tr>
          <td class="first-child">{{ $t('foundedLabel') }}</td>
          <td>{{ $t('founded') }}</td>
        </tr>
        <tr>
          <td class="first-child">{{ $t('employeesLabel') }}</td>
          <td>{{ $t('employees') }}</td>
        </tr>
        <tr>
          <td class="first-child">{{ $t('headquartersLabel') }}</td>
          <td>{{ $t('headquarters') }}</td>
        </tr>
        <tr>
          <td class="first-child">{{ $t('phoneLabel') }}</td>
          <td>{{ $t('phone') }}</td>
        </tr>
        <tr>
          <td class="first-child" v-html="$t('banks')"></td>
          <td v-html="`${$t('bank1')}<br>${$t('bank2')}`"></td>
        </tr>
        <tr>
          <td class="first-child" v-html="$t('qualifications')"></td>
          <td v-html="`${$t('qualification1')}<br>${$t('qualification2')}<br>${$t('qualification3')}`"></td>
        </tr>
      </table>
      <img :src="preloadedImages.png05" alt="Company Profile" class="img" v-if="preloadedImages.png05">
    </div>

    <!-- Welfare Section -->
    <div id="welfare" class="section welfare" v-observe-visibility="onVisibilityChange">
      <div class="vision-header">
      <h2>{{ $t('welfareTitle') }}</h2>
      </div>
      <div class="vision-content">
        <div class="welfare-text">
          <h3>{{ $t('insurance') }}</h3>
          <p>{{ $t('insuranceDetails') }}</p>
          <h3>{{ $t('vacation') }}</h3>
          <p>{{ $t('vacationDetails') }}</p>
          <h3>{{ $t('allowances') }}</h3>
          <p>{{ $t('allowancesDetails') }}</p>
        </div>
      </div>
      <img :src="preloadedImages.png06" alt="Company Profile" class="img" v-if="preloadedImages.png06">
    </div>

    <!-- Target Section -->
    <div id="target" class="section target" v-observe-visibility="onVisibilityChange">
      <div class="vision-header">
        <h2>{{ $t('TargetMainTitle') }}</h2>
      </div>
      <!-- <div class="target-container">
        <div class="vision-content">
          <p v-html="$t('Targetyear1')"></p>
          <p v-html="$t('Targetevent1')"></p>
        </div>
        <div class="vision-content">
          <p v-html="$t('Targetyear2')"></p>
          <p v-html="$t('Targetevent2')"></p>
        </div>
        <div class="vision-content">
          <p v-html="$t('Targetyear3')"></p>
          <p v-html="$t('Targetevent3')"></p>
        </div>
      </div> -->
      <div class="target-image">
        <img :src="preloadedImages.png07" alt="Company Profile" class="img" v-if="preloadedImages.png07">
      </div>
    </div>

    <!-- History Section -->
    <div id="history" class="section history" v-observe-visibility="onVisibilityChange">
      <div class="vision-header">
        <h2>{{ $t('HistoryTitle') }}</h2>
      </div>
      <div class="timeline-container">
        <div class="timeline-progress-line">
          <div class="glowing-dot"></div>
          <div class="flow-wave"></div>
        </div>
        <div class="timeline-item">
          <div class="year">{{ $t('Historyyear1') }}</div>
          <div class="event"><p v-html="$t('Historyevent1')"></p></div>
        </div>
        <div class="timeline-item">
          <div class="year">{{ $t('Historyyear2') }}</div>
          <div class="event"><p v-html="$t('Historyevent2')"></p></div>
        </div>
        <div class="timeline-item">
          <div class="year">{{ $t('Historyyear3') }}</div>
          <div class="event"><p v-html="$t('Historyevent3')"></p></div>
        </div>
        <div class="timeline-item">
          <div class="year">{{ $t('Historyyear4') }}</div>
          <div class="event"><p v-html="$t('Historyevent4')"></p></div>
        </div>
        <div class="timeline-item">
          <div class="year">{{ $t('Historyyear5') }}</div>
          <div class="event"><p v-html="$t('Historyevent5')"></p></div>
        </div>
        <div class="timeline-item">
          <div class="year">{{ $t('Historyyear6') }}</div>
          <div class="event"><p v-html="$t('Historyevent6')"></p></div>
        </div>
        <div class="timeline-item">
          <div class="year">{{ $t('Historyyear7') }}</div>
          <div class="event"><p v-html="$t('Historyevent7')"></p></div>
        </div>
        <div class="timeline-item">
          <div class="year">{{ $t('Historyyear8') }}</div>
          <div class="event"><p v-html="$t('Historyevent8')"></p></div>
        </div>
      </div>
      <img :src="preloadedImages.png08" alt="Company Profile" class="img" v-if="preloadedImages.png08">
    </div>

  </div>
</template>


<script>
import { openDB } from 'idb';

const dbPromise = openDB('images-db', 1, {
  upgrade(db) {
    db.createObjectStore('images');
  },
});

async function loadImageFromIndexedDB(name) {
  const db = await dbPromise;
  const blob = await db.get('images', name);
  if (!blob) return null;
  return URL.createObjectURL(blob);
}

export default {
  name: 'CompanyInfo',
  data() {
    return {
      activeIcon: null,
    };
  },
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    preloadedImages: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    navigateToSection(sectionId) {
      location.hash = `#${sectionId}`;
      location.hash = '';
    },
    onVisibilityChange(isVisible, entry) {
      if (isVisible) {
        entry.target.classList.add('visible');
        // Add animation for each paragraph inside the greeting section
        if (entry.target.id === 'greeting') {
          const paragraphs = entry.target.querySelectorAll('.greeting-text p');
          paragraphs.forEach((p, index) => {
            p.classList.remove('fade-in-visible');
            setTimeout(() => {
              p.classList.add('fade-in-visible');
            }, index * 150); // Adjust the delay time as needed
          });
        }
      } else {
        entry.target.classList.remove('visible');
        // Reset animation for each paragraph inside the greeting section
        if (entry.target.id === 'greeting') {
          const paragraphs = entry.target.querySelectorAll('.greeting-text p');
          paragraphs.forEach((p) => {
            p.classList.remove('fade-in-visible');
          });
        }
      }
    },
    setActiveIcon(index) {
      this.activeIcon = index;
    }
  },
  directives: {
    'observe-visibility': {
      inserted(el, binding) {
        const options = {
          threshold: 0.1 // Adjust as needed
        };
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (binding.value && typeof binding.value === 'function') {
              binding.value(entry.isIntersecting, entry);
            }
          });
        }, options);
        observer.observe(el);
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;700&display=swap');

.company-info {
  width: 100%;
  padding: 50px 0;
  background: url('../assets/img/background.webp') center/cover no-repeat fixed;
  text-align: center;
  font-family: 'Noto Sans JP', sans-serif;
  overflow-x: hidden; /* 防止横向滚动条 */

  .banner {
    position: relative;
    width: 100%;
    height: 420px;
    overflow: hidden;
    margin-bottom: 40px;

    &-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.4);
    }

    .banner-text {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: white;
      text-align: center;
      
      h1 {
        font-size: 40px;
        letter-spacing: 2px;
        font-weight: 400;
        font-family: 'Noto Sans JP', sans-serif;
      }

    }
  }

  .section {
    width: 60%;
    margin: 0 auto;
    opacity: 0;
    transform: translateY(20px);
    transition: opacity 0.6s ease, transform 0.6s ease;
    margin-bottom: 7vh;
    margin-top: -15px;

    img {
      padding-top: 30px;
      width: 70%;
    }

    &.visible {
      opacity: 1;
      transform: translateY(0);
    }

    .welfare-content {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: flex-start;
      text-align: left;
      line-height: 28px;

      p {
        font-size: 15px;
        margin-bottom: 25px;
        color: #414c64;

        strong {
          color: #2d3647;
          font-size: 18px;
          font-weight: 600;
          line-height: 34px;
        }
      }
    }
    
    .company-table {
      width: 100%;
      border-collapse: collapse;
      tr {
        td {
          padding: 10px 0 10px 100px;
          background:rgba(61, 147, 33, 0.06);
          font-weight: 600;
          text-align: left;
          width: 30%;
        }
  
        .first-child {
          width: 14%;
          padding-left: 15%;
          padding-top: 20px;
          padding-bottom: 24px;
        }
      }
      
    }

    .welfare-text {
      flex: 1;
      min-width: 200px;
      text-align: left;
      line-height: 28px;
      margin-left: 15%;

      h3 {
        font-size: 20px;
        color: #414c64;
        margin-bottom: 5px;
      }

      p {
        padding-bottom: 20px;
        font-size: 15px;
        margin-bottom: 20px;
      }
    }

    .welfare-image {
      max-width: 350px;
      width: 100%;
      text-align: center;
      padding-left: 20px;
      padding-top: 24px;
      margin-right: 5vw;

      img {
        width: 100%;
        height: auto;
        object-fit: cover;
        clip-path: inset(0 0 25% 0); /* 截取图像的上60% */
      }
    }
    
    .target-container {
      padding-left: 30%;
      padding-top: 0px;
      padding-bottom: 24px;
      display: flex;
      gap: 20px; /* 控制文字和图片间距 */
    }

    .target-content {
      flex: 1; /* 占据可用空间 */
    }

    .target-image {
      flex: 1.5;
    }

    /* 视觉差背景动画 */
    .vision::before {
      content: '';
      position: absolute;
      inset: 0;
      background: linear-gradient(45deg,rgb(0, 45, 14) 0%,rgb(0, 122, 35) 100%);
      z-index: -1;
      filter: url(#noiseFilter); /* 添加SVG噪声滤镜 */
    }

    /* 标题科技感光效 */
    .vision-header h2 {
      position: relative;
      display: inline-block;
      padding: 0 1em;
      text-shadow: 0 0 3px rgba(108, 255, 152, 0.5);
    }

    .vision-header h2::after {
      content: '';
      position: absolute;
      bottom: -10px;
      left: 50%;
      width: 80%;
      height: 3px;
      background: linear-gradient(90deg, transparent,rgb(76, 240, 114), transparent);
      transform: translateX(-50%);
      animation: laserScan 2.5s infinite;
    }

    /* 内容区立体卡片效果 */
    .vision-content {
      perspective: 1000px;
    }

    .vision-content year,
    .vision-content event,
    .vision-content p {
      position: relative;
      padding: 1.5em;
      margin: 1.5em 0;
      background:rgba(61, 147, 33, 0.06);
      border-radius: 8px;
      transform-style: preserve-3d;
      transition: transform 0.4s;
      text-align: left;
    }

    .vision-content year::before ,
    .vision-content event::before ,
    .vision-content p::before {
      content: '';
      position: absolute;
      inset: 0;
      border-radius: 8px;
      border: 1px solid rgba(76, 240, 139, 0.3);
      background:rgba(61, 147, 33, 0.06);
      transform: translateZ(-1px);
    }

    .vision-content year:hover ,
    .vision-content event:hover ,
    .vision-content p:hover {
      transform: translateY(-5px) rotateX(3deg);
    }

    /* 图片全息投影效果 */
    .img {
      border-radius: 8px;
      transition: transform 0.4s, filter 0.4s;
      filter: brightness(1.05) contrast(1.1);
    }

    /* 动态滤镜动画 */
    @keyframes laserScan {
      0% { transform: translateX(-150%); opacity: 0; }
      50% { opacity: 1; }
      100% { transform: translateX(50%); opacity: 0; }
    }

    /* 动态星际背景 */
    .companyprofile::before {
      content: '';
      position: absolute;
      inset: 0;
      background: 
        radial-gradient(circle at 70% 20%, #2a0a4a 0%, #0d0630 60%),
        linear-gradient(135deg,rgb(166, 165, 174) 30%,rgb(163, 157, 171) 100%);
      z-index: -1;
      animation: starPulse 12s infinite alternate;
    }

    /* 标题数据矩阵效果 */
    .companyprofile h2 {
      font-family: monospace;
      color:rgb(224, 255, 215);
      position: relative;
      padding: 0 2em;
    }

    .companyprofile h2::after {
      content: '▼';
      position: absolute;
      right: 0;
      bottom: -0.5em;
      color:rgb(20, 81, 36);
      animation: matrixFall 1s infinite steps(4);
    }

    .company-table tr {
      transition: all 0.3s;
      background: rgba(255,255,255,0.03);
      backdrop-filter: blur(0.5px);
    }

    .company-table tr:hover {
      transform: translateX(10px);
      background: linear-gradient(90deg, 
        transparent,
        rgba(138,43,226,0.1) 40%,
        transparent
      );
    }

    .company-table td {
      padding: 1.2em;
      position: relative;
      border: 1px solid transparent;
    }

    .company-table td:first-child {
      background: rgba(68, 165, 76, 0.46);
      font-weight: bold;
      border-image: linear-gradient(
        to bottom, 
        transparent 10%,
    rgb(169, 210, 172) 50%,
        transparent 90%
      ) 1;
    }

    .company-table tr:hover td:first-child::before {
      content: '';
      position: absolute;
      left: -5px;
      top: 0;
      height: 100%;
      width: 3px;
      background: linear-gradient(to bottom,rgb(251, 255, 0), transparent);
      animation: dataFlow 1.2s ease-out;
    }

    /* 图片量子跃迁效果 */
    .companyprofile .img {
      clip-path: polygon(5% 0, 95% 0, 100% 5%, 100% 95%, 95% 100%, 5% 100%, 0 95%, 0 5%);
      transition: all 0.4s;
      transform: scale(0.05); 
      filter: 
        drop-shadow(0 0 5pxrgb(144, 226, 43))
        contrast(1.1)
        brightness(1.05);
    }

    .companyprofile .img:hover {
      transform: 
        scale(1.03)
        rotate3d(1, 1, 0.5, 5deg);
      filter: 
        drop-shadow(0 0 5pxrgb(0, 30, 20))
        contrast(1.2)
        brightness(1.1);
      animation: quantumGlow 1.5s infinite;
    }

    /* 动态效果定义 */
    @keyframes starPulse {
      0% { opacity: 0.8; }
      100% { opacity: 1; }
    }

    @keyframes matrixFall {
      0% { opacity: 0; transform: translateY(-1em); }
      50% { opacity: 1; }
      100% { opacity: 0; transform: translateY(1em); }
    }

    @keyframes dataFlow {
      0% { opacity: 1; transform: translateY(-50%); }
      100% { opacity: 0; transform: translateY(150%); }
    }

    @keyframes quantumGlow {
      0%, 100% { filter: drop-shadow(0 0 5pxrgb(20, 30, 0)); }
      50% { filter: drop-shadow(0 0 5px #8a2be2); }
    }


    /* 内容卡片动画 */
    .content-card {
      background: white;
      padding: 2rem;
      border-radius: 15px;
      box-shadow: 0 10px 30px rgba(0,0,0,0.1);
      transition: transform 0.3s;
    }

    .content-card:hover {
      transform: translateY(-5px);
    }

    /* 时间轴设计 */
    .timeline-container {
      position: relative;
      margin: 2rem auto;
      padding: 4rem 0;
      overflow: hidden;
      height: 50%;
    }

    /* 动态时间线主体 */
    .timeline-progress-line {
      position: absolute;
      left: 50%;
      width: 6px;
      height: 100%;
      transform: translateX(-50%);
      background: linear-gradient(to bottom, 
        rgba(100, 255, 255, 0.2) 0%,
    rgb(20, 235, 138) 30%,
    rgb(12, 102, 66) 100%);
      transform: translateX(-50%);
      animation: flowGlow 2s infinite;
    }

    /* 流光粒子效果 */
    .glowing-dot {
      position: absolute;
      width: 8px;
      height: 8px;
      background: #fff;
      border-radius: 50%;
      filter: blur(1px);
      box-shadow: 0 0 20px #00f7ff;
      animation: 
        dotTravel 3s cubic-bezier(0.4, 0, 0.6, 1) infinite,
        particlePulse 1.5s ease-in-out infinite;
    }

    /* 动态波形装饰 */
    .flow-wave {
      position: absolute;
      width: 200%;
      height: 40px;
      background: radial-gradient(circle, 
        rgba(255,255,255,0.2) 0%,
        transparent 70%);
      animation: waveFlow 2s linear infinite;
    }

    .timeline-item {
      position: relative;
      width: 40%;
      padding: 1.5rem;
      background:rgba(61, 147, 33, 0.06);
      border-radius: 58px;
      margin: -2rem 0;
      box-shadow: 0 3px 10px rgba(0,0,0,0.1);
    }

    /* 时间节点装饰 */
    .timeline-item::before {
      content: '';
      position: absolute;
      left: 50%;
      transform: translateX(-20%);
      top: 0%;
      width: 24px;
      height: 24px;
      background:rgb(62, 147, 33);
      border: 3px solid #fff;
      border-radius: 50%;
      transform: translateY(-90%);
      box-shadow: 
        0 0 15px rgba(60, 219, 52, 0.8),
        inset 0 0 10px rgba(255,255,255,0.5);
      z-index: 2;
    }

    /* 悬浮互动 */
    .timeline-item:hover {
      transform: translateY(5px);
    }

    /* 调整交替布局 */
    .timeline-item:nth-child(odd) {
      left: 0%;
      margin-right: auto;
    }

    .timeline-item:nth-child(even) {
      left: auto;
      right: 0%;
      margin-left: auto;
    }

    /* 动态连接线重构 */
    .timeline-item::after {
      content: "";
      position: absolute;
      top: -20%;
      height: 3px;
      width: calc(80% + 20px); /* 计算精确长度 */
      background: linear-gradient(
        to var(--line-direction, right),
        transparent 30%,
    rgb(12, 172, 57) 70%,
        transparent 100%
      );
      animation: lineExtend 0.8s ease-out;
    }

    /* 设置连接线方向 */
    .timeline-item:nth-child(odd)::after {
      --line-direction: right;
      left: calc(0% + 90px);
    }

    .timeline-item:nth-child(even)::after {
      --line-direction: left;
      right: calc(0% + 90px);
    }

    /* 交互动画 */
    .animate-slide {
      opacity: 0;
      transform: translateX(-50px);
      transition: all 0.6s ease;
    }

    /* 关键帧动画 */
    @keyframes flowGlow {
      0% { opacity: 0.8; }
      50% { opacity: 1; filter: hue-rotate(20deg); }
      100% { opacity: 0.8; }
    }

    @keyframes dotTravel {
      0% { top: -10%; opacity: 0; }
      30% { opacity: 1; }
      100% { top: 110%; opacity: 0; }
    }

    @keyframes particlePulse {
      0%, 100% { transform: scale(1); }
      50% { transform: scale(1.5); }
    }

    @keyframes waveFlow {
      from { transform: translateY(-10px) rotate(5deg); }
      to { transform: translateY(100%) rotate(-5deg); }
    }

    @keyframes lineExtend {
      from {
        width: 0;
        opacity: 0;
      }
      to {
        width: calc(50% - 12px);
        opacity: 1;
      }
    }
  }

  h2 {
    font-size: 40px;
    font-weight: 400;
    color: #414c64;
  }

  p {
    font-size: 15px;
  }

  img {
    max-width: 100%;
    height: auto;
  }
}

@media (max-width: 768px) {
  .company-info {
    .section {
      width: 100%;
      padding: 20px;
      box-sizing: border-box; /* 确保内边距不会影响元素宽度 */

      img {
        padding-top: 30px;
        width: 100%;
      }

      .vision-content {
        flex-direction: column;
      }
  
      .float-img {
        max-width: 100%;
        margin-top: 2rem;
      }

      .company-table tr:hover td:first-child::before {
        display: none; 
      }

      .company-table {
        width: 100%;
        border-collapse: collapse;
        tr {
          td {
            padding: 10px 0;
            color: #414c64;
            font-weight: 600;
            text-align: left;
            width: 250px;
          }
    
          .first-child {
            width: 70px;
            padding-left: 5px;
            padding-right: 5px;
          }
        }
      }

      .welfare-content {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: flex-start;
        text-align: left;
        line-height: 28px;
        padding: 0;
  
        .welfare-text {
          flex: 1;
          min-width: 100px;
          text-align: left;
          line-height: 28px;
          padding: 0 4%;
          margin-left: 0;
    
          h3 {
            font-size: 20px;
            color: #414c64;
            margin-bottom: 5px;
          }
    
          p {
            padding-bottom: 20px;
            font-size: 15px;
            margin-bottom: 20px;
          }
        }
    
        .welfare-image {
          max-width: 100%;
          text-align: center;
          
          img {
            width: 100%;
            height: auto;
            object-fit: cover;
            clip-path: inset(0 0 40% 0);
          }
          
        .target-container {
           flex-direction: column;
          }
        }
      }

    /* 时间轴设计 */
    .timeline-container {
      margin: 1rem auto;
      padding: 0.1rem 0;
    }

      .timeline-item {
        position: relative;
        width: 90%;
        padding: 0.5rem;
        background:rgba(61, 147, 33, 0.06);
        border-radius: 58px;
        margin: 3rem 0;
        box-shadow: 0 1px 3px rgba(240, 238, 238, 0.1);
      }

      /* 时间节点装饰 */
      .timeline-item::before {
        left: 50%;
        right: 50%;
      }

      /* 悬浮互动 */
      .timeline-item:hover {
        transform: translateY(5px);
      }

      /* 调整交替布局 */
      .timeline-item:nth-child(odd) {
        left: 0%;
        margin-right: 0%;
      }

      .timeline-item:nth-child(even) {
        left: 0%;
        right: 0%;
        margin-left: 0%;
      }

      /* 动态时间线主体 */
      .timeline-progress-line {
          display: none; 
      }

      .timeline-item::after {
        display: none; 
      }
    }

    .banner {
      height: 320px; 
      .banner-text {
        h1 {
          font-size: 24px; 
        }
        h3 {
          font-size: 12px; 
        }
      }
    }

    h2 {
      font-size: 24px; 
    }

    .companyprofile .company-table,
    .welfare-content {
      padding: 0 20px;
      box-sizing: border-box; /* 确保内边距不会影响元素宽度 */
    }

    .company-table {
      width: 100%;
      border-collapse: collapse;
    }
  }
}
</style>
